import { trans } from '../../../functions';

export function collapseFilters() {
    $('.filter-checkbox').each(function () {
        let self = $(this);

        let filterCollapseCheckboxall = self.find('.form-check');
        filterCollapseCheckboxall.show();


        let filterCollapseCheckbox = self.children().eq(6).nextAll('.form-check');

    filterCollapseCheckbox.hide();
     self.next().remove();

        if (self.children().length > 6) {
            self.after(`<span class="btn-show-more">${trans('storefront::products.show_more')}</span>`);

            self.next().on('click', (e) => {
                let target = $(e.currentTarget);
                let showMoreText = trans('storefront::products.show_more');
                let showLessText = trans('storefront::products.show_less');

                target.text(target.text() === showMoreText ? showLessText : showMoreText);

                filterCollapseCheckbox.slideToggle(200);
            });
        }
    });

    const searchResultTop = document.querySelector('.search-result-top');

    if (searchResultTop) {
        searchResultTop.scrollIntoView({ behavior: 'smooth' });
    }

    
}
